import React, { Component } from 'react';
import { connect } from 'react-redux';
import { has } from 'lodash';

import {
  fetchUser,
} from '../../actions';


export default function (ComposedComponent) {
  class LoadUser extends Component {
    constructor(props) {
      super(props);
      if (has(props, 'authentication.token')) this.fetchUser();
    }

    fetchUser() {
      this.props.fetchUser(this.props.authentication);
    }

    render() {
      return <ComposedComponent {...this.props} />;
    }
  }

  const mapStateToProps = (state) => {
    const { users, session } = state;

    const user = users.byId[users.current];

    return {
      authentication: session.authentication,
      user,
    };
  };

  const mapDispatchToProps = {
    fetchUser,
  };

  return connect(mapStateToProps, mapDispatchToProps)(LoadUser);
}



// WEBPACK FOOTER //
// ./src/components/hoc/load-user.js